var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"avatar",class:{ active: _vm.attention },attrs:{"id":"avatar"}},[_c('span',{staticClass:"sumo-title"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }